import { z } from 'zod';
import { EvaluationSessionStatus } from '../enums.js';

export const getEvaluationSessionsParamsSchema = z.object({
  patient_id: z.uuid(),
});

export const getEvaluationSessionsSchema = z.object({
  limit: z
    .string()
    .optional()
    .default('10')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
  status: z.enum(EvaluationSessionStatus).optional(),
});

export type GetEvaluationSessionsParams = z.infer<typeof getEvaluationSessionsParamsSchema>;
export type GetEvaluationSessionsPayload = z.infer<typeof getEvaluationSessionsSchema>;
